<template>
  <div class="t-lesson">
    <div class="t-lesson__cost">{{ course.price }}<img src="/img/rub_big.png"></div>
    <div class="t-lesson__type">
      {{ course.typeText }}
      <template v-if="course.type == 3">, {{ course.lessons.length  + ' ' + declOfNum(course.lessons.length, classCountArr) }}</template>
    </div>
    <div class="t-lesson__duration" v-if="course.type !== 3">{{ duration }}</div>
    <ul class="t-courseItem__rate" v-if="$route.name !== 'courses_history'">
      <li>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z" :fill="course.rate >=1 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=1 ? 1 : 0.4"/>
          </g>
        </svg>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z" :fill="course.rate >=2 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=2 ? 1 : 0.4"/>
          </g>
        </svg>
      </li>
      <li>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z" :fill="course.rate >=3 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=3 ? 1 : 0.4"/>
          </g>
        </svg>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z" :fill="course.rate >=4 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=4 ? 1 : 0.4"/>
          </g>
        </svg>
      </li>
      <li>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z" :fill="course.rate >=5 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=5 ? 1 : 0.4"/>
          </g>
        </svg>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z" :fill="course.rate >=6 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=6 ? 1 : 0.4"/>
          </g>
        </svg>
      </li>
      <li>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z" :fill="course.rate >=7 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=7 ? 1 : 0.4"/>
          </g>
        </svg>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z" :fill="course.rate >=8 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=8 ? 1 : 0.4"/>
          </g>
        </svg>
      </li>
      <li>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M16.1631 4.26548C16.8573 2.65356 19.1427 2.65356 19.8369 4.26549L22.9379 11.4663C23.2275 12.1387 23.8612 12.5991 24.5901 12.6667L32.3968 13.3908C34.1443 13.5528 34.8506 15.7265 33.5321 16.8848L27.6419 22.0592C27.0919 22.5423 26.8499 23.2873 27.0108 24.0015L28.7346 31.6498C29.1205 33.3619 27.2715 34.7053 25.7624 33.8092L19.0211 29.8063C18.3917 29.4326 17.6083 29.4326 16.9789 29.8063L10.2376 33.8092C8.72851 34.7053 6.87952 33.3619 7.26539 31.6498L8.98917 24.0015C9.15013 23.2873 8.90806 22.5423 8.35809 22.0592L2.46795 16.8848C1.14943 15.7265 1.85568 13.5528 3.60322 13.3908L11.4099 12.6667C12.1388 12.5991 12.7725 12.1387 13.0621 11.4663L16.1631 4.26548Z" :fill="course.rate >=9 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=9 ? 1 : 0.4"/>
          </g>
        </svg>
        <svg width="18" height="36" viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="36">
            <rect width="18" height="36" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M-1.83691 4.26548C-1.14274 2.65356 1.14274 2.65356 1.83691 4.26549L4.93791 11.4663C5.22745 12.1387 5.86119 12.5991 6.59011 12.6667L14.3968 13.3908C16.1443 13.5528 16.8506 15.7265 15.5321 16.8848L9.64191 22.0592C9.09194 22.5423 8.84987 23.2873 9.01083 24.0015L10.7346 31.6498C11.1205 33.3619 9.27149 34.7053 7.76243 33.8092L1.02112 29.8063C0.391674 29.4326 -0.391674 29.4326 -1.02112 29.8063L-7.76243 33.8092C-9.27149 34.7053 -11.1205 33.3619 -10.7346 31.6498L-9.01083 24.0015C-8.84987 23.2873 -9.09194 22.5423 -9.64191 22.0592L-15.5321 16.8848C-16.8506 15.7265 -16.1443 13.5528 -14.3968 13.3908L-6.59012 12.6667C-5.8612 12.5991 -5.22745 12.1387 -4.93791 11.4663L-1.83691 4.26548Z" :fill="course.rate >=10 ? '#59DCED' : '#84C1F6'" :fill-opacity="course.rate >=10 ? 1 : 0.4"/>
          </g>
        </svg>
      </li>
    </ul>

    <template v-if="$route.name === 'courses_info'">
      <button class="t-btn" v-if="!course.belonging" @click.prevent="ScrollToCalendar()"><span>{{ lessonText.setDate }}</span></button>
      <router-link class="t-btn" v-if="course.belonging" :to="{name: 'courses_edit'}"><span>{{ lessonText.edit }}</span></router-link>
    </template>

    <template v-else>
      <div class="t-lesson__state" v-html="state[data.state - 1]"></div>
      <div class="t-lesson__date">
        <span>{{ dateLesson }}</span>
        {{ timeLesson }}
      </div>

      <button class="t-btn" @click.prevent="OpenReview()" v-if="this.data.state === 3"><span>{{ lessonText.addReview }}</span></button>
      <button class="t-btn t-btn_white" @click.prevent="Cancel()" v-else><span>{{ lessonText.cancel }}</span></button>

    </template>

  </div>
</template>

<script>
    import {store} from '../store'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        props: ['data'],
        data(){
            return {
                state: store.getters['staticText/lessonText'].state
            }
        },
        computed: {
            ...mapGetters('staticText', ['classCountArr', 'monthArr', 'weekArr', 'hoursArr', 'minuteArr', 'lessonText']),
            ...mapGetters('coursesList', ['course']),
            duration(){
                if(this.course.type !== 3){
                    let h = Math.floor(this.course.duration / 60);
                    let m = this.course.duration - (h * 60);

                    if (h > 0)
                        if (m > 0)
                            return h + ' ' + this.declOfNum(h, this.hoursArr) + ' ' + m + ' ' + this.declOfNum(m, this.minuteArr);
                        else
                            return h + ' ' + this.declOfNum(h, this.hoursArr);
                    else
                        return m + ' ' + this.declOfNum(m, this.minuteArr);
                }
                return false
            },
            dateLesson(){
                if(this.data){
                    let date = new Date(this.data.lessons[0].date_time);

                    return date.getDate() + ' ' + this.monthArr[date.getMonth()] + ', ' + this.weekArr[date.getDay()];
                }
                return false
            },
            timeLesson(){
                if(this.data) {
                    let date = new Date(this.data.lessons[0].date_time);

                    let hours = date.getHours();
                    let minutes = date.getMinutes();

                    let time_start = [];
                    time_start.push(hours < 10 ? '0' + hours : hours);
                    time_start.push(minutes < 10 ? '0' + minutes : minutes);

                    time_start = time_start.join(':');

                    minutes = hours * 60 + minutes;
                    minutes += this.data.lessons[0].duration;
                    hours = Math.floor(minutes / 60);
                    minutes -= hours * 60;

                    let time_end = [];
                    time_end.push(hours < 10 ? '0' + hours : hours);
                    time_end.push(minutes < 10 ? '0' + minutes : minutes);

                    time_end = time_end.join(':');

                    return time_start + '-' + time_end;
                }
                return false
            }
        },
        methods: {
            ...mapActions('msg', ['showMsg']),
            ...mapActions('modal', ['modalDialogType_reviewOpen']),
            ...mapActions('coursesList', ['SetReviewId', 'LoadHistory']),
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            ScrollToCalendar(){
                document.querySelector('.t-calendar').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            },
            Cancel(){
                this.$http.delete('courses/' + this.course.id + '/history/' + this.data.id)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success){
                            this.showMsg(this.lessonText.msg);
                            this.LoadHistory({id: this.course.id});
                        } else{
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            OpenReview(){
                this.SetReviewId(this.data.id);
                this.modalDialogType_reviewOpen();
            }
        }
    }
</script>

<style lang="sass">
.t-lesson
  &__cost
    display: flex
    align-items: center
    color: $blue
    font-size: 22px
    line-height: 1.2
    font-weight: bold
    margin-bottom: 8px
    img
      margin-left: 10px
  &__type
    font-size: 22px
    line-height: 1.2
    font-weight: bold
    margin-bottom: 10px
  &__duration
    color: $grey
    margin: 0 0 16px
    line-height: 1.1
  &__state
    font-weight: bold
    margin: 0 0 24px
    color: $blue
    font-size: 22px
    line-height: 1.2
    span
      display: block
      margin-top: 10px
      font-size: 14px
      font-weight: normal
      color: $grey
  &__date
    margin: 0 0 16px
    span
      display: block
      margin-bottom: 8px
      font-weight: bold
  &__addRate
    label
      font-weight: bold
      margin-bottom: 8px
  &__hint
    margin: 8px 0 16px
    font-size: 14px
    color: $grey
    &_error
      margin: 24px 0 0
    a
      color: $blue
  .t-btn
    + .t-btn
      margin-top: 16px
  .t-courseItem__rate
    margin: 0 0 24px
  > *:last-child
    margin-bottom: 0

.t-addRate
  display: flex
  align-items: center
  justify-content: flex-start
  list-style-type: none
  li
    width: 40px
    height: 40px
    background: url('/img/star_b.png') no-repeat center
    &._pointer
      cursor: pointer
    &._active
      background: url('/img/star_b_active.png') no-repeat center
</style>


// WEBPACK FOOTER //
// src/vue_components/Lesson.vue